import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import AllRatesTable from 'components/AllRatesTable';

import {
  makeGetCurrencyAllRates,
  getLocationParamsValues,
  getCurrenciesPairInfo,
  getCurrencyRatesIsFetching,
  // for withSeoData
  getCurrencyRatesByCurrencyPair,
  getExistedConverterType,
} from 'selectors';

const getCurrencyAllRates = makeGetCurrencyAllRates();

const mapStateToProps = (state, props) => {
  const { sourceValue, sourceType } = getLocationParamsValues(state, props);

  return {
    ...getCurrenciesPairInfo(state, props),
    ...getCurrencyRatesByCurrencyPair(state, props),

    sourceType,
    sourceValue,
    existedConverterType: getExistedConverterType(state, props),
    rates: getCurrencyAllRates(state, props),
    ratesIsFetching: getCurrencyRatesIsFetching(state),
  };
};

const AllRatesTableContainer = injectIntl(
  withRouter(connect(mapStateToProps)(AllRatesTable))
);

export default AllRatesTableContainer;
